import React, { useMemo } from 'react'

import './BarChart.scss'

export default function BarChart({ data }) {
  const maxValue = useMemo(() => Math.max(...(data?.map((i) => i.value) || [])), [data])

  if (!Array.isArray(data)) {
    return <div>No data</div>
  }
  return (
    <div className='BarChart'>
      {data.map((item) => (
        <div key={item.label} className='BarChart__item'>
          <label>{item.label}</label>
          <div style={{ height: `${(item.value / maxValue) * 80}%` }} className='BarChart__item__bar'></div>
          <div className='BarChart__item__tooltip'>{item.value}</div>
        </div>
      ))}
    </div>
  )
}
